import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20beautiful%20artistic%20anime%20style%20scene%20with%20cherry%20blossom%20petals%20falling%20gently%20against%20a%20warm%20sunset%20sky%2C%20soft%20pink%20and%20coral%20gradient%20atmosphere%2C%20minimal%20composition%2C%20dreamy%20and%20romantic%20mood%2C%20ethereal%20lighting%2C%20subtle%20manga%20panel%20textures%20blended%20in%20the%20background%2C%20abstract%20geometric%20shapes%20in%20warm%20tones&width=1600&height=900&seq=sakura-hero-bg&orientation=landscape"
          alt="樱花漫画 - 漫画下载离线阅读"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>
      </div>

      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4 w-full">
        <div className="max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/20 mb-6">
            <i className="ri-sparkling-2-line text-accent-400 text-sm w-4 h-4 flex items-center justify-center"></i>
            <span className="text-sm text-background-50 font-medium">日漫韩漫国漫 · 全部免费</span>
          </div>
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 leading-tight">
            樱花漫画
          </h1>
          <p className="text-base md:text-lg text-background-200 mb-8 max-w-2xl mx-auto leading-relaxed">
            漫画下载离线阅读 · 免费全集收藏追更 · 好看的漫画大全
            <br className="hidden md:block" />
            日漫韩漫国漫免费看，轻松追更，随时随地畅享漫画世界
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/all"
              className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap text-sm"
            >
              <i className="ri-book-read-line mr-2 w-4 h-4 inline-flex items-center justify-center"></i>
              开始阅读
            </Link>
            <Link
              to="/category/riman"
              className="px-8 py-3 bg-background-50/15 hover:bg-background-50/25 backdrop-blur-sm text-background-50 font-medium rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap text-sm border border-background-50/20"
            >
              <i className="ri-compass-3-line mr-2 w-4 h-4 inline-flex items-center justify-center"></i>
              探索日漫
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}